export var getTopDate = function (date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};
export var getFirstDate = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
};
export var isSameMonth = function (dateFrom, dateTo) {
    return (dateFrom.getFullYear() == dateTo.getFullYear() &&
        dateFrom.getMonth() == dateTo.getMonth());
};
export var isSameDate = function (dateFrom, dateTo) {
    return (dateFrom.getFullYear() == dateTo.getFullYear() &&
        dateFrom.getMonth() == dateTo.getMonth() &&
        dateFrom.getDate() == dateTo.getDate());
};
export var numberToDate = function (date) {
    return date ? new Date(date) : undefined;
};
export var dateToNumber = function (date) {
    return date
        ? Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
        : undefined;
};
export var addDay = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
};
//# sourceMappingURL=utils.js.map